import styled from "styled-components";
import { palette } from "styled-theme";

const StepsWizardWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
   .closeBtn {
    position: absolute;
    left: ${(props) => (props["direction"] === "rtl" ? "10px" : "inherit")};
    right: ${(props) => (props["direction"] === "ltr" ? "10px" : "inherit")};
  }
  .steps {
    border-bottom: 1px solid ${palette("border", 0)};
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 16px 0px;
    .ant-steps {
      width: 150px;
    }

    .ant-steps-item-wait, .ant-steps-item-finish {
      &:hover {
        .ant-steps-item-icon {
       border-color:#F5A522 !important;
     }
     span {
       color: #F5A522 !important;
     }
     }
    }

    .ant-steps-item-icon {
       border-color:#F5A522;
     }
    .ant-steps-item-process .ant-steps-item-icon{
      background:#F5A522;

    }
     .ant-steps-item-icon > .ant-steps-icon{
       color:#F5A522;
     }
     .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon{
       color:#ffffff;
     }
     .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
       background-color:#F5A522;

     }
  }

  .ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:not(:first-child)::before{
    width:0;
  }
  .inner{
    width: 100%;
     .details-slide{
      display: flex;
      .details-outer{
        .actions{
          display: flex;
          width: 100%;
          padding: 20px 20px 20px 20px;
          justify-content: space-between;
          }
      }
      .details{
        padding: 24px 90px 24px 90px;
        &.scheduling{
          padding:24px 90px 24px 90px;
          .actions{
            display: flex;
            width: 100%;
            padding: 90px 0px 0px 0px;
            justify-content: space-between;
            }
        }

        .main {
          display: flex;
          flex-direction: column;
          h2.ant-typography {
            margin-bottom:24px;
          }
          .ant-typography-secondary{
            margin-bottom:6px;
          }
          .wage {
            padding: 20px;
            border:1px solid ${palette("border", 0)};
            margin: 20px 0;
            border-radius: 10px;
          }
          .employee-container{
            display:flex;
            flex-direction: column;
            align-items: flex-start;
            margin: 0 0 24px 0;
            .icon-container{
              width:40px;
              height:40px;
              border-radius:20px;
              display:flex;
              align-items:center;
              justify-content:center;
              margin: 0 0 -20px 40px;
              z-index: 1;
              background-color: ${palette("surfaceColor", 0)};
              span {
                font-size: 20px;
                color: ${palette("primary", 0)};
              }
            }
            .employee{
              padding:30px;
              display: flex;
              flex-direction: row;
               background-color: ${palette("bgColor", 0)};
              border-radius:30px;
               h2.ant-typography {
                  margin-bottom: 0;
              }
               h5.ant-typography{
                margin:0;
                font-weight: 400;
              }
              .seperator{
                border: 1px solid ${palette("border", 0)};
                width:100%;
                margin:16px 0;
              }
              .employee-type{
                display: flex;
                flex-direction: column;
                margin-bottom: 16px;
                .ant-typography-secondary{
                  margin:0;
                 }
              }
              .ant-avatar {
                width:120px;
                height:120px;
              }
              .employee-details {
                display: flex;
                flex-direction: column;
                min-width: 200px;
              }
            }
          }

         }
      }

    }
    .matching-slide{
      display: flex;
      .filters{
        padding:20px 50px 0px 50px;
        width:300px;
        .divider{
          height: 30px;
        }
        .header{
          display: flex;
          justify-content:space-between;
        }
        .sliderContainer{
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          padding-top: 10px;
          .img{
             width: 137px;
             height: 61px;
             object-fit: contain;
           }

           .distanceFilter{
             .ant-slider-track{
               background-color: ${palette("primary", 0)};
             }
           }
           .classificationFilter{
             .ant-slider-track{
               background-color: #fd9b5b;
             }
           }
           .totalFilter{
             .ant-slider-track{
               background-color: #58cb7d;
             }
           }
        }



      }
      .wage{
         padding: 20px;
         border:1px solid ${palette("border", 0)};
         margin-right: ${(props) =>
           props["direction"] === "rtl" ? "20px" : "inherit"};
         margin-left: ${(props) =>
           props["direction"] === "ltr" ? "20px" : "inherit"};
           border-radius: 10px; 
      }
      .matching {
        display: flex;
        flex-direction: column;
        .main {
          display: flex;
          flex: 1;
          .ant-table table{
            height: 100%;
          }
        }
        .actions{
          width:100%;
          padding-bottom:24px;
          display: flex;
          align-items:center;
          justify-content:center;
        }
      }

    }


  }
  }
  .walkthrough{
    width:300px;
    background-color: ${palette("bgColor", 0)};
    .inner{
        margin: 30px;
        padding: 24px;
        border-radius: 16px;
        background-color: ${palette("surfaceColor", 0)};
        width:auto;
        .imgContainer{
          width: 100%;
          height: 97px;
          border-radius: 12px;
          background-color: #dcf0ff;
          .img{
            width: 165px;
            height: 126px;
            margin-top: -30px;
             object-fit: contain;
          }
        }
      .ant-typography + h4.ant-typography{
        margin-top:0px;
      }
    }
  }
`;

export default StepsWizardWrapper;
